import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import BonusClaimList from "./BonusClaimList";

const initialFilteringState = {
  start_date: "",
  end_date: "",
  member: "",
  date: "",
};

class BonusClaim extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabId: "BONUS_CLAIM_LIST", // BONUS_LIST
    };
  }

  onChangeTabIdHandler = (event, tabId, data) => {
    event?.preventDefault(); // prevents page reload

    this.setState({ tabId }, () => {
      switch (tabId) {
        case "BONUS_CLAIM_LIST":
          this.setState({
            ...this.state,
            // bonusList: data
          });
          break;
        default:
          break;
      }
    });
  };

  render() {
    const { t } = this.props;

    return (
      <Auxiliary>
        {(this.state.tabId === "BONUS_CLAIM_LIST") && (
          <>
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary tabs-style-2 mt-3">
                  <div className="tab-menu-heading">
                    <div className="tabs-menu1">
                      <ul className="nav panel-tabs main-nav-line">
                        <li>
                          <a
                            href="/#"
                            id="bonus_list"
                            onClick={(e) =>
                              this.onChangeTabIdHandler(e, "BONUS_CLAIM_LIST")
                            }
                            style={{ borderTopWidth: 0 }}
                            className={`nav-link bg-white ${
                              this.state.tabId === "BONUS_CLAIM_LIST" ? "active" : ""
                            }`}
                          >
                            {t("global.bonus-claim-list")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </>
        )}

        {this.state.tabId === "BONUS_CLAIM_LIST" && <BonusClaimList />}

      </Auxiliary>
    );
  }
}

const mapDispatchToProps = (_) => {
  return {};
};

const mapStateToProps = (reduxState) => {
  return {
    currentUser: reduxState.currentUser.data,
    currentPermission: reduxState.currentUser.data.permission,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(BonusClaim));
